import * as React from "react";
import {
  IconCloseCircle,
  IconCheckCircle,
  SvgIcon,
} from "@origin-digital/ods-icons";

export const StopIcon = () => (
  <SvgIcon titleAccess="OCP projects stop">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M14.8995 4C15.1647 4 15.4191 4.10536 15.6066 4.29289L19.7071 8.3934C19.8946 8.58094 20 8.83529 20 9.10051L20 14.8995C20 15.1647 19.8946 15.4191 19.7071 15.6066L15.6066 19.7071C15.4191 19.8946 15.1647 20 14.8995 20H9.1005C8.83529 20 8.58093 19.8946 8.3934 19.7071L4.29289 15.6066C4.10536 15.4191 4 15.1647 4 14.8995V9.10041C4 8.83525 4.10531 8.58095 4.29278 8.39342L8.3919 4.293C8.57944 4.1054 8.83385 4 9.09912 4H14.8995ZM7.58789 10.3762C7.03561 10.3762 6.58789 10.8239 6.58789 11.3762V12.6235C6.58789 13.1758 7.03561 13.6235 7.58789 13.6235H16.4121C16.9644 13.6235 17.4121 13.1758 17.4121 12.6235V11.3762C17.4121 10.8239 16.9644 10.3762 16.4121 10.3762H7.58789Z"
      fill="#EC0000"
    />
  </SvgIcon>
);

export const ArchiveIcon = () => (
  <SvgIcon titleAccess="OCP projects archive">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M4 4C3.44772 4 3 4.44772 3 5V9C3 9.55228 3.44772 10 4 10L4 19C4 19.5523 4.44772 20 5 20H19C19.5523 20 20 19.5523 20 19V10C20.5523 10 21 9.55228 21 9V5C21 4.44772 20.5523 4 20 4H4ZM19 8H5V6H19V8ZM6 18V10H18V18H6ZM10 12C9.44772 12 9 12.4477 9 13C9 13.5523 9.44772 14 10 14H14C14.5523 14 15 13.5523 15 13C15 12.4477 14.5523 12 14 12H10Z"
      fill="#737373"
    />
  </SvgIcon>
);

export const PlayIcon = () => (
  <SvgIcon titleAccess="OCP projects play">
    <path
      d="M6.5 5.78233C6.5 5.00154 7.35483 4.52195 8.02119 4.92889L18.2025 11.1465C18.8409 11.5363 18.8409 12.4635 18.2025 12.8534L8.02119 19.0709C7.35483 19.4779 6.5 18.9983 6.5 18.2175V5.78233Z"
      fill="#0A5FD2"
    />
  </SvgIcon>
);

export const FolderIcon = () => (
  <SvgIcon titleAccess="OCP projects folder">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M9 3C8.44772 3 8 3.44772 8 4V6H5C3.89543 6 3 6.89543 3 8V18C3 19.1046 3.89543 20 5 20H19C20.1046 20 21 19.1046 21 18V8C21 6.89543 20.1046 6 19 6H16V4C16 3.44772 15.5523 3 15 3H9ZM10 6H14V5H10V6ZM9 8H15H19V11H13H11H5V8H9ZM5 13V18H19V13H14V14C14 14.5523 13.5523 15 13 15H11C10.4477 15 10 14.5523 10 14V13H5Z"
      fill="#505050"
    />
  </SvgIcon>
);

export const GasIcon = () => (
  <SvgIcon titleAccess="OCP projects folder">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M6 3H8V5H16V3H18V5C19.1046 5 20 5.89543 20 7V12H20.25C20.6642 12 21 12.3358 21 12.75C21 13.1642 20.6642 13.5 20.25 13.5H20H18.5H5.5H4H3.75C3.33579 13.5 3 13.1642 3 12.75C3 12.3358 3.33579 12 3.75 12H4V7C4 5.89543 4.89543 5 6 5V3ZM18 6.5H6C5.72386 6.5 5.5 6.72386 5.5 7V12H18.5V7C18.5 6.72386 18.2761 6.5 18 6.5ZM20 14H4V19C4 20.1046 4.89543 21 6 21H18C19.1046 21 20 20.1046 20 19V14ZM8 8H6.5V10H8V8ZM9 8H10.5V10H9V8ZM13 8H11.5V10H13V8ZM14 8H15.5V10H14V8ZM18 8H16.5V10H18V8Z"
      fill="#505050"
    />
  </SvgIcon>
);

export const MessageReadIcon = () => (
  <SvgIcon titleAccess="OCP projects folder">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12 2.95669L3.9131 7.00021L12 11.0437L20.0869 7.00021L12 2.95669ZM12.4472 1.22374C12.1657 1.08297 11.8343 1.08297 11.5528 1.22374L2.89792 5.55125C1.70391 6.14826 1.70391 7.85218 2.89792 8.44918L11.5528 12.7766C11.8343 12.9174 12.1657 12.9174 12.4472 12.7766L21.1021 8.44918C22.2961 7.85218 22.2961 6.14826 21.1021 5.55124L12.4472 1.22374Z"
      fill="#505050"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M2 7.00007V8.00018V17.0001C2 18.1046 2.89543 19.0001 4 19.0001H20C21.1046 19.0001 22 18.1046 22 17.0001V8.00018V7.00007C22 6.93448 21.9968 6.86963 21.9907 6.80566L20 8.00007V9.00018V13.0001V17.0001H4V13.0001V9.00018V8.00007L2 7.00007Z"
      fill="#ABABAB"
    />
  </SvgIcon>
);

export const MessageNewIcon = () => (
  <SvgIcon titleAccess="OCP projects folder">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M4 7H20L12.2236 10.8883C12.0828 10.9587 11.9172 10.9587 11.7764 10.8883L4 7ZM2 8.00011V7C2 5.89543 2.89543 5 4 5H20C21.1046 5 22 5.89543 22 7V8.00011V17C22 18.1046 21.1046 19 20 19H4C2.89543 19 2 18.1046 2 17V8.00011ZM20 9.00011V17H4V9.00011L11.5528 12.7765C11.8343 12.9173 12.1657 12.9173 12.4472 12.7765L20 9.00011Z"
      fill="#EC0000"
    />
  </SvgIcon>
);

export const CompleteIcon = () => (
  <SvgIcon titleAccess="OCP complete">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12 21C16.9706 21 21 16.9706 21 12C21 10.546 20.6552 9.17263 20.043 7.95702L11.0002 16.9998L6.12016 12.1198C5.72844 11.7281 5.72957 11.0927 6.12267 10.7024C6.51381 10.314 7.14539 10.3151 7.53516 10.7048L11.0002 14.1698L18.9256 6.25191C17.2747 4.26506 14.7851 3 12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21Z"
      fill="#008906"
    />
  </SvgIcon>
);

export const EWRIcon = () => (
  <SvgIcon color="primary">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="m8.836 10.604 1.808-1.862 3.616-3.724a1.253 1.253 0 0 1 1.808 0c.5.515.5 1.348 0 1.862l-.483.498c.84.231 1.633.686 2.291 1.364 1.498-1.542 1.498-4.043 0-5.585a3.758 3.758 0 0 0-5.424 0L7.028 8.742c-1.498 1.542-1.498 4.043 0 5.585a3.758 3.758 0 0 0 5.424 0l-1.808-1.861c-.5.514-1.309.514-1.808 0-.5-.515-.5-1.348 0-1.862Zm6.328 2.792-1.808 1.862-3.616 3.724c-.5.514-1.31.514-1.808 0-.5-.515-.5-1.348 0-1.862l.483-.498a5.057 5.057 0 0 1-2.292-1.364c-1.497 1.542-1.497 4.043 0 5.585a3.758 3.758 0 0 0 5.425 0l5.424-5.585c1.498-1.542 1.498-4.043 0-5.585a3.758 3.758 0 0 0-5.424 0l1.808 1.862a1.253 1.253 0 0 1 1.808 0c.5.514.5 1.347 0 1.861Z"
    />
  </SvgIcon>
);

export const BulkActionsIcon = () => (
  <SvgIcon color="secondaryB" titleAccess="Bulk actions">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M11.5 5.9V6V6.5H16.5C17.0523 6.5 17.5 6.94772 17.5 7.5V12.5H18H18.1H19.5V11V6V4.5H18H13H11.5V5.9ZM17.5 14H18.1H19.5H20C20.5523 14 21 13.5523 21 13V12.5V4.5V4C21 3.44771 20.5523 3 20 3H19.5H11.5H11C10.4477 3 10 3.44772 10 4V4.5V5.9V6.5H7.5C6.94771 6.5 6.5 6.94772 6.5 7.5V10H4C3.44772 10 3 10.4477 3 11V20C3 20.5523 3.44772 21 4 21H13C13.5523 21 14 20.5523 14 20V17.5H16.5C17.0523 17.5 17.5 17.0523 17.5 16.5V14ZM8 8V10H13C13.5523 10 14 10.4477 14 11V16H16V8H8ZM12.5 11.5V19.5H4.5V11.5H12.5ZM5.94219 15.0998L7.38639 16.544L10.9117 13.0282C11.2043 12.7364 11.678 12.7367 11.9703 13.0289C12.2628 13.3214 12.2629 13.7957 11.9703 14.0883L7.37187 18.6867L4.86354 16.1784C4.56568 15.8805 4.56568 15.3976 4.86354 15.0998C5.1614 14.8019 5.64433 14.8019 5.94219 15.0998Z"
    />
  </SvgIcon>
);

export const FilterProjectIcon = () => (
  <SvgIcon color="secondaryB" titleAccess="Filter">
    <path d="M11 18H13C13.55 18 14 17.55 14 17C14 16.45 13.55 16 13 16H11C10.45 16 10 16.45 10 17C10 17.55 10.45 18 11 18ZM3 7C3 7.55 3.45 8 4 8H20C20.55 8 21 7.55 21 7C21 6.45 20.55 6 20 6H4C3.45 6 3 6.45 3 7ZM7 13H17C17.55 13 18 12.55 18 12C18 11.45 17.55 11 17 11H7C6.45 11 6 11.45 6 12C6 12.55 6.45 13 7 13Z" />
  </SvgIcon>
);

export const SortResultIcon = () => (
  <SvgIcon titleAccess="Sort results">
    <path d="M2 17L5.75 7H7.9L11.65 17H9.6L8.75 14.6H4.9L4.1 17H2ZM5.5 12.9H8.1L6.9 9.15H6.75L5.5 12.9ZM13.7 17V15.1L18.75 8.8H13.9V7H20.95V8.9L15.95 15.2H21V17H13.7ZM9 5L12 2L15 5H9ZM12 22L9 19H15L12 22Z" />
  </SvgIcon>
);

export const RequestStatusCompletedIcon = () => (
  <SvgIcon color="promote" variant="solid">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M7.64065 6.10722L18.126 16.5678L19.5979 15.1387L18.4779 14.0214L21.3216 11.1844C22.5034 10.0054 21.3216 8.96888 21.3216 8.96888L19.0255 6.67821L22.6522 3.06046L21.1432 1.55615L17.5076 5.18287L14.9585 2.63979C13.9645 1.64814 12.7186 3.06046 12.7186 3.06046L10.0672 5.70562L9.05519 4.69602L7.64065 6.10722ZM16.6015 17.8586L6.11612 7.39813L4.64423 8.82727L5.76417 9.94455L2.92047 12.7815C1.73869 13.9605 2.92047 14.997 2.92047 14.997L5.21657 17.2877L1.41162 21.084L2.92061 22.5883L6.73456 18.783L9.28365 21.326C10.2777 22.3177 11.5235 20.9054 11.5235 20.9054L14.1749 18.2602L15.1869 19.2698L16.6015 17.8586Z"
    />
  </SvgIcon>
);

export const RequestStatusInProgressIcon = () => (
  <SvgIcon color="info">
    <path d="M12 2C6.5 2 2 6.5 2 12C2 17.5 6.5 22 12 22C17.5 22 22 17.5 22 12C22 6.5 17.5 2 12 2ZM15.55 15.8L11.47 13.29C11.17 13.11 10.99 12.79 10.99 12.44V7.75C11 7.34 11.34 7 11.75 7C12.16 7 12.5 7.34 12.5 7.75V12.2L16.34 14.51C16.7 14.73 16.82 15.2 16.6 15.56C16.38 15.91 15.91 16.02 15.55 15.8Z" />
  </SvgIcon>
);

export const RequestStatusDraftIcon = () => (
  <SvgIcon color="primaryB">
    <path d="M3 17.25V21h3.75L17.81 9.94l-3.75-3.75L3 17.25ZM20.71 7.04a.996.996 0 0 0 0-1.41l-2.34-2.34a.996.996 0 0 0-1.41 0l-1.83 1.83 3.75 3.75 1.83-1.83Z" />
  </SvgIcon>
);

export const RequestStatusAssignedIcon = () => (
  <SvgIcon color="primaryB">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M11 8C11 5.79 12.79 4 15 4C17.21 4 19 5.79 19 8C19 10.21 17.21 12 15 12C12.79 12 11 10.21 11 8ZM7 17C7 14.34 12.33 13 15 13C17.67 13 23 14.34 23 17V19C23 19.55 22.55 20 22 20H8C7.45 20 7 19.55 7 19V17ZM5.10783 9.4388V7.53633C5.10783 7.05805 5.66239 6.82423 5.98074 7.15371L8.84596 10.119C9.05135 10.3316 9.05135 10.6611 8.84596 10.8736L5.98074 13.8389C5.66239 14.1791 5.10783 13.9452 5.10783 13.467V11.5645H2.02696C1.46213 11.5645 1 11.0862 1 10.5016C1 9.91708 1.46213 9.4388 2.02696 9.4388H5.10783Z"
    />
  </SvgIcon>
);

export const RequestStatusFinishedIcon = () => (
  <IconCheckCircle color="positive" variant="solid" />
);

export const RequestStatusCancelledIcon = () => (
  <IconCloseCircle color="critical" variant="solid" />
);

export const RequestStatusPausedIcon = () => (
  <SvgIcon color="secondary">
    <path d="M12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM10 16C9.45 16 9 15.55 9 15V9C9 8.45 9.45 8 10 8C10.55 8 11 8.45 11 9V15C11 15.55 10.55 16 10 16ZM14 16C13.45 16 13 15.55 13 15V9C13 8.45 13.45 8 14 8C14.55 8 15 8.45 15 9V15C15 15.55 14.55 16 14 16Z" />
  </SvgIcon>
);

export const MoveActionsIcon = () => (
  <SvgIcon color="neutral">
    <path d="M12 20C11.45 20 10.9792 19.8042 10.5875 19.4125C10.1958 19.0208 10 18.55 10 18C10 17.45 10.1958 16.9792 10.5875 16.5875C10.9792 16.1958 11.45 16 12 16C12.55 16 13.0208 16.1958 13.4125 16.5875C13.8042 16.9792 14 17.45 14 18C14 18.55 13.8042 19.0208 13.4125 19.4125C13.0208 19.8042 12.55 20 12 20ZM12 14C11.45 14 10.9792 13.8042 10.5875 13.4125C10.1958 13.0208 10 12.55 10 12C10 11.45 10.1958 10.9792 10.5875 10.5875C10.9792 10.1958 11.45 10 12 10C12.55 10 13.0208 10.1958 13.4125 10.5875C13.8042 10.9792 14 11.45 14 12C14 12.55 13.8042 13.0208 13.4125 13.4125C13.0208 13.8042 12.55 14 12 14ZM12 8C11.45 8 10.9792 7.80417 10.5875 7.4125C10.1958 7.02083 10 6.55 10 6C10 5.45 10.1958 4.97917 10.5875 4.5875C10.9792 4.19583 11.45 4 12 4C12.55 4 13.0208 4.19583 13.4125 4.5875C13.8042 4.97917 14 5.45 14 6C14 6.55 13.8042 7.02083 13.4125 7.4125C13.0208 7.80417 12.55 8 12 8Z" />
  </SvgIcon>
);

export const ElecAddsAltsIcon = () => (
  <SvgIcon color="neutral" titleAccess="Electricity change request">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8 2C4.135 2 1 5.135 1 9a6.99 6.99 0 0 0 3 5.74V17c0 .55.45 1 1 1h6c.55 0 1-.45 1-1v-2.26A6.99 6.99 0 0 0 15 9c0-3.865-3.135-7-7-7ZM5 21c0 .55.45 1 1 1h4c.55 0 1-.45 1-1v-1H5v1Zm5-7.305.855-.595A5.003 5.003 0 0 0 13 9.005c0-2.755-2.245-5-5-5s-5 2.245-5 5c0 1.63.8 3.16 2.145 4.1L6 13.7V16h4v-2.305Z"
    />
    <path d="M24 6h-3v3h-2V6h-3V4h3V1h2v3h3v2Z" />{" "}
  </SvgIcon>
);

export const ElecAbolishmentsIcon = () => (
  <SvgIcon color="neutral" titleAccess="Electricity abolishment request">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M1 9c0-3.865 3.135-7 7-7s7 3.135 7 7a6.99 6.99 0 0 1-3 5.74V17c0 .55-.45 1-1 1H5c-.55 0-1-.45-1-1v-2.26A6.99 6.99 0 0 1 1 9Zm9.855 4.1-.855.595V16H6v-2.3l-.855-.595A5.005 5.005 0 0 1 3 9.005c0-2.755 2.245-5 5-5s5 2.245 5 5c0 1.625-.8 3.155-2.145 4.095Z"
    />
    <path d="M6 22c-.55 0-1-.45-1-1v-1h6v1c0 .55-.45 1-1 1H6ZM24 4h-7v2h7V4Z" />{" "}
  </SvgIcon>
);

export const GasAddsAltsIcon = () => (
  <SvgIcon color="neutral" titleAccess="Gas change request">
    <path d="M20 6h3V4h-3V1h-2v3h-3v2h3v3h2V6Z" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M13.746 8.815A7.718 7.718 0 0 1 16 14.245a7.785 7.785 0 0 1-2.254 5.46 7.693 7.693 0 0 1-5.427 2.26.201.201 0 0 0-.034.006c-.013.003-.026.006-.04.006-.02 0-.04-.005-.062-.009-.018-.003-.036-.007-.054-.008a7.694 7.694 0 0 1-5.289-2.256 7.786 7.786 0 0 1-2.254-5.46c0-1.925.751-3.928 2.254-5.43l5.453-5.44 5.453 5.44Zm-3.49 5.612c.948 1.476 1.08 3.731.406 5.435a5.775 5.775 0 0 0 3.408-5.424c-.04-1.832-.625-2.977-1.693-4.04L8.292 6.186l-4.085 4.169c-1.068 1.058-1.653 2.248-1.693 4.083v.003l-.002.155a5.773 5.773 0 0 0 3.297 5.212c-.649-1.698-.513-3.92.426-5.381l2.01-3.128 2.01 3.128Zm-2.804.781c-.806 1.251-.806 3.44 0 4.692.132.206.262.35.387.451l.034.003c.14.01.278.02.42.02.095 0 .188-.007.28-.014l.075-.005a1.88 1.88 0 0 0 .392-.455c.805-1.251.805-3.44 0-4.692l-.794-1.236-.794 1.236Z"
    />
  </SvgIcon>
);

export const GasAbolishmentsIcon = () => (
  <SvgIcon color="neutral" titleAccess="Gas abolishment request">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M14.746 8.815A7.718 7.718 0 0 1 17 14.245a7.785 7.785 0 0 1-2.254 5.46 7.693 7.693 0 0 1-5.427 2.26.201.201 0 0 0-.034.006c-.013.003-.026.006-.04.006-.02 0-.04-.005-.062-.009-.018-.003-.036-.007-.054-.008a7.694 7.694 0 0 1-5.289-2.256 7.786 7.786 0 0 1-2.254-5.46c0-1.925.751-3.928 2.254-5.43l5.453-5.44 5.453 5.44Zm-3.49 5.612c.948 1.476 1.08 3.731.406 5.435a5.775 5.775 0 0 0 3.408-5.424c-.04-1.832-.625-2.977-1.693-4.04L9.292 6.186l-4.085 4.169c-1.068 1.058-1.653 2.248-1.693 4.083v.003l-.002.155a5.773 5.773 0 0 0 3.297 5.212c-.649-1.698-.513-3.92.426-5.381l2.01-3.128 2.01 3.128Zm-2.804.781c-.806 1.251-.806 3.44 0 4.692.132.206.262.35.387.451l.034.003c.14.01.278.02.42.02.095 0 .188-.007.28-.014l.075-.005c.126-.102.258-.247.392-.455.805-1.251.805-3.44 0-4.692l-.794-1.236-.794 1.236Z"
    />
    <path d="M23 4h-7v2h7V4Z" />
  </SvgIcon>
);

export const DBFormAddsAltsIcon = () => (
  <SvgIcon color="neutral" titleAccess="DB form change request">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8 2C4.135 2 1 5.135 1 9a6.99 6.99 0 0 0 3 5.74V17c0 .55.45 1 1 1h6c.55 0 1-.45 1-1v-2.26A6.99 6.99 0 0 0 15 9c0-3.865-3.135-7-7-7Zm2 11.695.855-.595A5.003 5.003 0 0 0 13 9.005c0-2.755-2.245-5-5-5s-5 2.245-5 5c0 1.63.8 3.16 2.145 4.1L6 13.7V16h4v-2.305Z"
    />
    <path d="M5 21c0 .55.45 1 1 1h4c.55 0 1-.45 1-1v-1H5v1Z" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M23.73 6.07c0 1.18-.4 2.13-1.2 2.85-.8.72-1.883 1.08-3.25 1.08h-2.37V2.17h2.4c1.373 0 2.454.343 3.24 1.03.787.687 1.18 1.643 1.18 2.87Zm-1.66 0c0-.747-.253-1.327-.76-1.74-.506-.42-1.16-.63-1.96-.63h-.82v4.77h.8c.827 0 1.49-.21 1.99-.63.5-.427.75-1.017.75-1.77Z"
    />
    <path d="M21 18h3v-2h-3v-3h-2v3h-3v2h3v3h2v-3Z" />
  </SvgIcon>
);

export const DBFormAbolishmentsIcon = () => (
  <SvgIcon color="neutral" titleAccess="DB form abolishment request">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8 2C4.135 2 1 5.135 1 9a6.99 6.99 0 0 0 3 5.74V17c0 .55.45 1 1 1h6c.55 0 1-.45 1-1v-2.26A6.99 6.99 0 0 0 15 9c0-3.865-3.135-7-7-7Zm2 11.695.855-.595A5.003 5.003 0 0 0 13 9.005c0-2.755-2.245-5-5-5s-5 2.245-5 5c0 1.63.8 3.16 2.145 4.1L6 13.7V16h4v-2.305Z"
    />
    <path d="M5 21c0 .55.45 1 1 1h4c.55 0 1-.45 1-1v-1H5v1Z" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M23.73 6.07c0 1.18-.4 2.13-1.2 2.85-.8.72-1.883 1.08-3.25 1.08h-2.37V2.17h2.4c1.373 0 2.454.343 3.24 1.03.787.687 1.18 1.643 1.18 2.87Zm-1.66 0c0-.747-.253-1.327-.76-1.74-.506-.42-1.16-.63-1.96-.63h-.82v4.77h.8c.827 0 1.49-.21 1.99-.63.5-.427.75-1.017.75-1.77Z"
    />
    <path d="M17 13h7v2h-7v-2Z" />
  </SvgIcon>
);
